import {useEffect, useState} from "react";
import {useRouter} from "next/router";
import localized from "../../locale/locales";
import Container from "../Container";
import Title from "../Title";
import Typo from "../Typo";
import Select from "../Select";
import ConceptCard from "../ConceptCard";
import {defaultConceptsFilters, filterConcepts} from "../../helpers/concepts";

function Filters({activeFilters, setActiveFilters}) {
    const {locale} = useRouter();
    const lang = localized[locale].conceptsIndex.concepts;

    return (
        <div>
            <Container className="pt-20 pb-40 md:pb-48 text-center flex flex-col items-center gap-8">
                <header>
                    <Title className="max-w-[16ch]">
                        {lang.title}
                    </Title>
                </header>
                <div className="flex flex-wrap gap-6 justify-center ">
                    {Object.keys(lang.filters).filter(i => i !== 'labels').map((filterLabel, filterGroupIndex) => {
                        const label = lang.filters.labels[filterLabel];
                        const optionsObject = lang.filters[filterLabel];
                        const options = Object.keys(optionsObject).map((key) => ({
                            value: key,
                            label: optionsObject[key]
                        }));

                        return (
                            <Select
                                key={`Filter: ${filterGroupIndex}`}
                                label={label}
                                onChange={(filterName) => {
                                    setActiveFilters({
                                        ...activeFilters,
                                        [filterLabel]: filterName
                                    })
                                }}
                                options={options}
                                className="z-20"
                                selected={activeFilters[filterLabel]}
                                onClear={() => {
                                    setActiveFilters({...activeFilters, [filterLabel]: null})
                                }}
                            />
                        )
                    })}
                </div>
            </Container>
        </div>
    )
}

export default function SectionConcepts({showFilters = false, location = null, setConceptsCount}) {
    const {locale} = useRouter();
    const lang = localized[locale].conceptsIndex.concepts;

    const [activeCard, setActiveCard] = useState(null);

    const [activeFilters, setActiveFilters] = useState(defaultConceptsFilters);

    const [activeConcepts, setActiveConcepts] = useState(filterConcepts(activeFilters, location));

    // const resetFilters = () => setActiveFilters(defaultConceptsFilters);

    useEffect(() => {
        setActiveConcepts(filterConcepts(activeFilters, location));
    }, [activeFilters, lang, location]);

    useEffect(() => {
        if (setConceptsCount) {
            setConceptsCount(activeConcepts.length);
        }
    }, [activeConcepts, setConceptsCount]);

    return (
        <>
            {showFilters && (
                <Filters activeFilters={activeFilters}
                         setActiveFilters={setActiveFilters}
                />
            )}

            {activeConcepts.length === 0 && (
                <Container className="text-center">
                    <Typo className="text-xl">{lang.noResults}</Typo>
                </Container>
            )}

            {activeConcepts.length > 0 && (
                <div className="bg-black relative z-10">
                    <Container className="relative w-full py-px">
                        <div
                            className="flex flex-col items-center sm:flex-row sm:items-start flex-wrap gap-8 justify-center -my-16 sm:-my-28">
                            {activeConcepts.map((concept) => {
                                return (
                                    <ConceptCard {...concept}
                                                 key={`ConceptCard: ${concept.title}`}
                                        // gradient fixes the issue with corners in safari
                                                 className="max-w-[400px] w-full sm:max-w-[calc(50%-1rem)] lg:max-w-[calc(33.333%-1.333rem)]"
                                                 onMouseEnter={() => setActiveCard(concept.title)}
                                                 onMouseOut={() => setActiveCard(null)}
                                                 active={activeCard === concept.title}
                                    />
                                )
                            })}
                        </div>
                    </Container>
                </div>
            )}
        </>
    )
}
